import * as React from 'react';

import { warn } from 'helper/debug';
import { ucfirst } from 'helper/string';

import { HistoryType, MatchType } from 'types/withRouter';
import Controllers, { PatchController } from './controller';

type PatchViewProps = {
	history: HistoryType;
	match: MatchType & {
		params: {
			id: string;
		};
	};
};

const getQueryParams = (queryString: string = window.location.search): Object => {
	const pairs: Array<string> = queryString.slice(1).split('&');
	const result = {};

	pairs.forEach((pair: string): void => {
		const decoupledPair: Array<string> = pair.split('=');
		result[decoupledPair[0]] = decodeURIComponent(decoupledPair[1] || '');
	});

	return JSON.parse(JSON.stringify(result));
};

export default class Patch extends React.Component<PatchViewProps> {
	public static displayName = 'PatchRouter';

	public shouldComponentUpdate() {
		return false;
	}

	public componentDidMount() {
		const { history, match } = this.props;
		const id = match.params.id.toString() || 'default';
		const params: Object = getQueryParams(history.location.search);
		const controllerName: string = `${ucfirst(id)}Controller`;
		const DedicatedControllerClass: new (...args: any) => PatchController =
			Controllers[controllerName] || Controllers.DefaultController;

		try {
			const controller = new DedicatedControllerClass(history, match, params);
			controller.prepare(() => {
				controller.handle();
			});
		} catch (err) {
			warn(
				[
					`${controllerName} - There went something wrong:`,
					`${err.message || err || 'unknown'}`,
					`\n\tat patch #${id}`,
					`\n\tat file ~/PatchView/controller/${controllerName}.js `,
				].join(' ')
			);
		}
	}

	public render() {
		return null;
	}
}
